import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", {
        email: email.trim().toLowerCase(),
        origin_url: window.location.origin,
      });
    } catch { /* always show success — no account enumeration */ }
    setLoading(false);
    setSent(true);
  };

  return (
    <div className="df-shell df-safe-top min-h-screen flex flex-col justify-center px-6">
      <div className="df-fade-in">
        <div className="flex items-center gap-3 mb-8">
          <img src="/molaroo-mark.png" alt="Molaroo" className="h-14 w-14 rounded-2xl object-contain bg-white shadow-sm" />
          <div>
            <div className="text-2xl font-heading font-bold tracking-tight text-slate-900 leading-none">Molaroo</div>
            <div className="text-sm text-slate-500 mt-1">Your income, organised.</div>
            <div className="text-xs text-slate-400 mt-0.5">by NavScora</div>
          </div>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="df-card p-6 text-center">
            <span className="mx-auto mb-3 h-12 w-12 rounded-full bg-[#E6F4F1] text-[#0D786A] flex items-center justify-center"><MailCheck size={22} /></span>
            <h1 className="text-xl font-bold text-slate-900 mb-1">Check your email</h1>
            <p className="text-slate-500 text-sm">If an account exists for <span className="font-medium text-slate-700">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.</p>
            <Link to="/login" data-testid="forgot-back-login" className="inline-block mt-5 text-[#0D786A] font-semibold df-pressable">Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900 mb-1">Forgot password</h1>
            <p className="text-slate-500 mb-8">Enter your email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-slate-700">Email</Label>
                <Input id="email" data-testid="forgot-email" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-12 rounded-xl bg-white" required />
              </div>
              <Button type="submit" data-testid="forgot-submit" disabled={loading}
                className="w-full h-12 rounded-xl bg-[#0D786A] hover:bg-[#0A6055] text-base font-semibold df-pressable">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
            <p className="text-center text-sm text-slate-500 mt-6">
              Remembered it?{" "}
              <Link to="/login" data-testid="forgot-to-login" className="text-[#0D786A] font-semibold df-pressable">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
